import React, {Component} from "react";
import Form from 'react-bootstrap/Form';

import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faPlus} from '@fortawesome/free-solid-svg-icons';

import AccTypeSelecter from "./AccTypeSelecter";
import AccessorySelecter from "./AccessorySelecter";
import AccConnSelecter from "./AccConnSelecter";
import {helper}  from "./../app.js"; 

export default class AccessoryConfigurator extends Component 
{
    constructor (props)
    {
        super(props);

        this.state = {
            type: this.props.type,
            accessory: this.props.accessory,
            cover: this.props.cover,
            connector: this.props.connector
        };

        this.addAccessory = this.addAccessory.bind(this);
        this.processSelected = this.processSelected.bind(this);
    }
    canAdd ()
    {
        return !helper.isNotObjectOrEmpty(this.state.accessory);
    }
    addAccessory ()
    {
        if (this.canAdd())
        {
            const accessory = {
                accessory: this.state.accessory,
                cover: this.state.cover,
                connector: this.state.connector
            };

            this.props.on_select_item(accessory, 'accessory');
    
            this.setState({
                type: '',
                accessory: null,
                cover: null,
                connector: null
            });
            /*
            Uncaught (in promise) DOMException: Failed to execute 'put' on 'IDBObjectStore': function onClose() {
                return _this5._manager.setState({
                alert_message: ''
                });
            } could not be cloned.
            at http://ostec-next.conf/scripts.js:27892:37
            at createTransaction (http://ostec-next.conf/scripts.js:27645:9)
            at http://ostec-next.conf/scripts.js:27876:13
            */
        }        
    }
    processSelected (item, type, showInfo = true)
    {
        if (type in this.state)
        {
            const newState = {[type]: item};

            switch (type)
            {
                case 'type':
                    
                    Object.assign(newState, {
                        accessory: null,
                        cover: null,            
                        connector: null
                    });
                    this.setState(newState);                     
                    break;

                case 'accessory':

                    if (null === item)
                    {
                        this.setState(
                        {
                            accessory: null,
                            cover: null,            
                            connector: null
                        });
                    }
                    else if ('quantity' in item)
                    {
                        this.setState(newState);
                    }

                    //console.log('accessory', item, showInfo);

                    this.props.on_select_item(item, 'info', showInfo);
                    break;

                default:

                    if (null === item || 'quantity' in item || 'products' in item)
                    {
                        this.setState(newState);
                    }

                    this.props.on_select_item(item, 'info', showInfo);
                    break;
            }
        }
    }
    render() 
    {
        const tray = this.props.tray,
            type = this.state.type,
            hasTray = !helper.isNotObjectOrEmpty(tray),
            trayId = hasTray ? tray.id : '',
            trayArticul = hasTray ? tray.articul : '',
            hasAccessory = !helper.isNotObjectOrEmpty(this.state.accessory),
            accessoryId = hasAccessory ? this.state.accessory.id : '',
            accArticul = hasAccessory ? this.state.accessory.articul : '',
            accQuantity = hasAccessory ? this.state.accessory.quantity : 1,
            canAdd = this.canAdd();

        return (
            <Form>                
                <AccTypeSelecter key={`at_${trayId}`} on_select={this.processSelected} tray_articul={trayArticul} init_type={type} />
                <AccessorySelecter key={`as_${trayId}_${type}`} on_select={this.processSelected} tray_articul={trayArticul} type={type} init_accessory={this.state.accessory} init_cover={this.state.cover} />
                <AccConnSelecter key={`acon_${trayId}_${accessoryId}`} on_select={this.processSelected} tray_articul={trayArticul} acc_articul={accArticul} acc_quantity={accQuantity} init_connector={this.state.connector} />
                <Button onClick={this.addAccessory} disabled={!canAdd} variant={canAdd ? 'danger' : 'secondary'}>
                    <FontAwesomeIcon icon={faPlus} />{'   ДОБАВИТЬ В ПРОЕКТ'}
                </Button>
            </Form>
        );
    }
}
